// 注册默认的 setters
export var setterRegistry = function setterRegistry(ctx) {
  return {
    init: function init() {
      var _require;
      var config = ctx.config;
      if (config.get('disableDefaultSetters')) return;
      var builtinSetters = (_require = require('@alilc/lowcode-engine-ext')) === null || _require === void 0 ? void 0 : _require.setters;
      if (builtinSetters) {
        ctx.setters.registerSetter(builtinSetters);
      }
    }
  };
};
setterRegistry.pluginName = '___setter_registry___';